import { setCountries, setSelectedCountry } from '.'
import * as ApiBase from '../../APIBase'
import { getCookieToken } from '../../utils/cookieToken'
import { findSelectedCountryObj } from '../../utils/countires'

export const getCountries = () => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const token = getCookieToken()
  const URL = `/${subPath}/customer/all_countries`
  const json = await ApiBase.get(URL, {}, token)

  if (json.all_countries) {
    const defaultCountry = getState().merchant.home_country
    const countryObj = findSelectedCountryObj(json.all_countries, defaultCountry, 'code')
    dispatch(setCountries(json.all_countries))
    dispatch(setSelectedCountry(countryObj))
  }

  return json
}
